import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Modal,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import userServices from "../services/user.services";
import { useFormik } from "formik";
import { UserSchema } from "../schema/UserSchema";
import { toast } from "react-toastify";
import stateServices from "../services/state.services";
import cityServices from "../services/city.services";
import UserForm from "./User/UserForm";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { useNavigate } from "react-router-dom";
import TableNoDataIndication from "./common/TableNoDataIndication";

const { SearchBar } = Search;
const UserList = () => {
  const [modal, setModal] = React.useState(false);
  const toggle = () => setModal(!modal);
  const [users, setUsers] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedRow, setSelectedRow] = useState();
  const [isAddMode, setIsAddMode] = useState("Add");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const getAllUsers = () => {
    const result = userServices
      .getAllUsers()
      .then((res) => {
        if (res.data.status === true) {
          const rs = res.data.users.filter((item) => {
            return item.user_type_id === 4;
          });

          setUsers(rs);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("error", error);
        setLoading(false);
      });
  };
  const filterUser = users.map((center) => {
    states.map((state) => {
      if (center.state === state.unique_id) {
        center.state_name = state.name;
      }
    });
    return center;
  });
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      fullName: "",
      mobile: "",
      address: "",
      city: "",
      state: "",
    },
    validationSchema: UserSchema("user"),
    onSubmit: async (values, actions) => {
      const reqBody = {
        name: values.fullName,
        gender: "male",
        mobile: values.mobile,
        email: values.email,
        user_type_id: 1,
        password: values.password,
        address: values.address,
        state: values.state,
        city: values.city,
        latitude: "45.1254",
        longitude: "46.2548",
      };

      const result = await userServices.createUser(reqBody);
      if (result.data.status === true) {
        actions.resetForm();
        getAllUsers();
        toggle();
        toast.success("User registration successfully", {
          toastId: "registration_success",
          autoClose: 3000,
        });
      } else {
        toast.error(result.data.message, {
          toastId: "registration_fail",
          autoClose: 3000,
        });
      }
    },
    enableReinitialze: true,
  });

  const tblColumn = [
    {
      dataField: "",
      text: "Sr.No.",
      formatter: (value, row, index) => {
        return <>{index + 1}</>;
      },
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      formatter: (value, row) => {
        return <span onClick={() => { navigate(`/user/bookings/${row._id}`) }} className="cursor-pointer">{row.name}</span>;
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: false,
    },
    {
      dataField: "mobile",
      text: "Mobile",
      sort: false,
    },
    {
      dataField: "gender",
      text: "Gender",
      sort: true,
    },
    {
      dataField: "address",
      text: "Address",
      sort: true,
    },
    {
      dataField: "user_status",
      text: "Status",
      formatter: (value, row) => {
        return (
          <BootstrapSwitchButton
            checked={row.user_status === 1 ? true : false}
            onChange={(checked) => {
              console.log("Checked ", checked);
              handleChangeStatus(row._id, checked);
            }}
            offstyle="secondary"
          />
        );
      },
    },
    // {
    //     dataField: '',
    //     text: 'action',
    //     formatter: (value, row) => {
    //         return (
    //             <UncontrolledDropdown>
    //                 <DropdownToggle className="card-drop" tag="a">
    //                     <i className="lni lni-more-alt font-size-16" />
    //                 </DropdownToggle>
    //                 <DropdownMenu className="dropdown-menu-end action_drop_down">
    //                     <DropdownItem onClick={() => {
    //                         setSelectedRow(row);
    //                         setIsAddMode('Edit');
    //                         setModal(true)
    //                     }}>
    //                         <i className="lni lni-pencil font-size-16 text-success me-1" />{" "}
    //                         Edit
    //                     </DropdownItem>
    //                     <DropdownItem onClick={() => {
    //                         localStorage.setItem("isCustomerEdit", value);
    //                         deleteUserById(row._id)
    //                     }}>
    //                         <i className="lni lni-trash font-size-16 text-danger me-1" />{" "}
    //                         Delete
    //                     </DropdownItem>
    //                 </DropdownMenu>
    //             </UncontrolledDropdown>
    //         );
    //     }
    // }
  ];

  // const defaultSorted = [
  //   {
  //     dataField: "created_at",
  //     order: "desc",
  //   },
  // ];
  const pzipcodeOptions = {
    sizePerPzipcode: 10,
    totalSize: filterUser.length, // replace later with size(customers),
    custom: true,
  };

  const deleteUserById = async (id) => {
    const result = await userServices.deleteUserById({ id: id });
    if (result.data.status === true) {
      toast.success(result.data.message, {
        toastId: "userDelete_success",
        autoClose: 3000,
      });
      getAllUsers();
    } else {
      toast.error(result.data.message, {
        toastId: "userDelete_faild",
        autoClose: 3000,
      });
    }
  };

  const handleChangeStatus = async (id, status) => {
    console.log("status", status);
    const result = await userServices.updateUserById(id, {
      user_status: status,
    });
    if (result.data.status === true) {
      getAllUsers();
      toast.success("Status updated successfully", {
        toastId: "update_success",
        autoClose: 3000,
      });
    } else {
      toast.error(result.data.message, {
        toastId: "update_fail",
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    getAllUsers();
    const getAllStates = stateServices.getAllStates().then((res) => {
      if (res.data.status === true) {
        setStates(res.data.states);
      }
    });
    const getAllCity = cityServices.getAllCity().then((res) => {
      if (res.data.status === true) {
        setCities(res.data.cities);
      }
    });
  }, []);
  return (
    <React.Fragment>
      {/*page-wrapper*/}
      <div className="page-wrapper">
        {/*page-content-wrapper*/}
        <div className="page-content-wrapper">
          <div className="page-content">
            <>
              {/*breadcrumb*/}
              <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                {/* <div className="breadcrumb-title pe-3">Users</div> */}
                <div className="ps-3">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0 p-0">
                      <li className="breadcrumb-item">
                        <a href="/">{/* <i className="bx bx-home-alt" /> */}</a>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        User
                      </li>
                    </ol>
                  </nav>
                </div>
                <div className="ms-auto">
                  <div className="btn-group">
                    <Modal isOpen={modal} toggle={toggle} size="lg">
                      <UserForm
                        toggle={toggle}
                        isAddMode={isAddMode}
                        cities={cities}
                        states={states}
                        getAllUsers={getAllUsers}
                        selectedRow={selectedRow}
                      />
                    </Modal>
                  </div>
                </div>
              </div>
              {/*end breadcrumb*/}
              <div className="card">
                {/* <div className="card-header">
                                <div className="card-title">
                                    <h6 className="mb-0 pt-2 brand-color">User Mode</h6>
                                </div>    
                            </div> */}
                <div className="card-body">
                  <React.Fragment>
                    <PaginationProvider
                      pagination={paginationFactory(pzipcodeOptions)}
                      keyField="id"
                      columns={tblColumn}
                      data={filterUser}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="_id"
                          columns={tblColumn}
                          data={filterUser}
                          search
                        >
                          {(toolkitProps) => (
                            <React.Fragment>
                              <Row className="mb-2" style={{ display: "none" }}>
                                <Col md="4">
                                  <div className="search-box me-2 mb-2 d-inline-block">
                                    <div className="status-relative"></div>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="text-right col-md-2 offset-md-10 mb-2">
                                    <label className="pe-3">Search</label>
                                    <SearchBar
                                      className="w-100"
                                      {...toolkitProps.searchProps}
                                    />
                                  </div>
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      noDataIndication={
                                        <TableNoDataIndication loading={loading} />
                                      }
                                      keyField={"id"}
                                      responsive
                                      bordered={false}
                                      striped={false}
                                      // defaultSorted={defaultSorted}
                                      classes={
                                        "table table-striped align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              {filterUser.length > 0 && (
                                <Row className="align-items-md-center mt-30">
                                  <Col className="inner-custom-pagination mt-2 d-flex">
                                    <div className="d-inline">
                                      <SizePerPageDropdownStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                    <div className="text-md-right ms-auto">
                                      <PaginationListStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              )}
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </React.Fragment>
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserList;
